const SnackbarReducer = (state = {}, action) => {
  switch (action.type) {
    case 'OPEN_SNACKBAR': {
      return {
        ...state,
        open: true,
        message: action.message,
        type: action.msgType,
        time: action.time
      };
    }
    case 'CLOSE_SNACKBAR': {
      return {
        ...state,
        open: false,
        message: null,
        type: null,
        time: 0
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default SnackbarReducer;
